import React from 'react';

import {
  Clock01Icon,
  CursorInfo01Icon,
  NoteIcon,
  Settings01Icon,
  UserGroupIcon,
} from '@hugeicons/core-free-icons';

import { DataCard } from 'components/Cards/DataCards/DataCard';
import { Button } from 'components/FormComponents';

const checkmateKnowledgeBaseUrl = 'https://help.checkmate.tech/';

const knowledgeBaseCards = [
  {
    text: `General information about how Checkmate works.`,
    caption: 'General',
    icon: CursorInfo01Icon,
    link: 'https://help.checkmate.tech/en/collections/9137385-general',
  },
  {
    text: `Creating, progressing, and managing different kinds of reference & background checks.`,
    caption: 'Reference and background checks',
    icon: UserGroupIcon,
    link: 'https://help.checkmate.tech/en/collections/9137386-reference-and-background-checks',
  },
  {
    text: `Creating, customising, and managing different questionnaires used for referees and candidates.`,
    caption: 'Questionnaires',
    icon: NoteIcon,
    link: 'http://help.checkmate.tech/en/collections/9137387-questionnaires',
  },
  {
    text: `Configuring, and utilising Checkmate for ongoing current employee periodic checks.`,
    caption: 'Renewal checks',
    icon: Clock01Icon,
    link: 'https://help.checkmate.tech/en/collections/9137393-renewal-checks',
  },
  {
    text: `Customise and manage different company or account settings in Checkmate.`,
    caption: 'Company and account settings',
    icon: Settings01Icon,
    link: 'https://help.checkmate.tech/en/collections/9137390-company-and-account-settings',
  },
];

export const KnowledgeBaseCards = () => {
  return (
    <div className="d-flex flex-column u-gap-medium align-items-center">
      <Button
        type="link"
        onClick={() => window.open(checkmateKnowledgeBaseUrl, '_blank')}
        className="u-flex-align-self-center u-font-weight-400">
        Or learn more about Checkmate...
      </Button>
      <div className="d-flex flex-wrap u-gap-large justify-content-center">
        {knowledgeBaseCards.map(knowledgeBaseCard => (
          <div className="u-min-width-20 u-max-width-20" key={knowledgeBaseCard.text}>
            <DataCard
              link={knowledgeBaseCard?.link}
              icon={knowledgeBaseCard.icon}
              gap="small"
              large
              displayStatus={false}
              caption={knowledgeBaseCard.caption}
              title={knowledgeBaseCard.metric}
              description={knowledgeBaseCard.text}
              className="u-height-200 justify-content-center"
            />
          </div>
        ))}
      </div>
    </div>
  );
};
